export default {"src":"/komodo/_next/static/media/markets_insider.bea2101e.svg","height":146,"width":450,"blurWidth":0,"blurHeight":0};